export default __webpack_public_path__ + "static/media/tutorials.fed3eb18.svg";